"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AffiliatesController = function () {
  function AffiliatesController(AffiliatesService, FilterService, AuthService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AffiliatesController);
    this.affiliatesService = AffiliatesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(AffiliatesController, [{
    key: "$onInit",
    value: function $onInit() {
      this.affiliateTypeOptions = {
        dataSource: [{ value: _constants2.default.affiliateType.CREDIT, text: "Credit" }, { value: _constants2.default.affiliateType.SUBSCRIPTION, text: "Membership" }],
        dataTextField: "text",
        dataValueField: "value"
      };

      this.paymentTypeOptions = {
        dataSource: [{ value: _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180, text: "Complete Childcare" }, { value: _constants2.default.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240, text: "Tutoring + Childcare" }],
        dataTextField: "text",
        dataValueField: "value"
      };

      this.secondaryPaymentTypeOptions = {
        dataSource: [{ value: _constants2.default.userPaymentType.NONE, text: "None" }, { value: _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30, text: "Paid Membership" }],
        dataTextField: "text",
        dataValueField: "value"
      };
    }

    // https://demos.telerik.com/kendo-ui/grid/detailtemplate.

  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.affiliatesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        toolbar: [{ name: "create", text: "Create New Partnership" }],
        detailInit: this.detailInit.bind(this),
        detailTemplate: kendo.template($("#template").html()),
        noRecords: {
          template: "No Partnerships."
        },
        // dataBound: function() {
        //     this.expandRow(this.tbody.find("tr.k-master-row").first());
        // },
        columns: [
        // { field: "code", title: "Code", filterable: false, sortable: false, width: "4rem" },
        { field: "affiliateName", title: "Partner Name", filterable: false, sortable: false, width: "8rem" }, {
          field: "fullName", title: "Referrer", filterable: false, attributes: { "class": "col-name" }, width: "8rem",
          template: function template(dataItem) {
            return dataItem.jugglerId ? "<a target=\"_blank\" class=\"cell\" href=\"/users/" + dataItem.jugglerId + "\">" + dataItem.fullName + "</a>" : 'None';
          }
        }, { field: "jugglerTypes", title: "Account Type", filterable: false, width: "6rem", template: function template(dataItem) {
            return "" + _this._getAccountType(dataItem);
          } }, { field: "affiliateType", title: "Type", filterable: false, width: "6rem", template: function template(dataItem) {
            return "" + _this._getAffiliateDetails(dataItem);
          } }, { field: "activationsCount", title: "Usage", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getActivationDetails(dataItem);
          } },
        // { field: "startDate", title: "Start Date", filterable: false, width: "4rem", template: `#= startDate ? kendo.toString(new Date(startDate), 'dd/MM/yyyy'): '-' #` },
        // { field: "expireDate", title: "Expire Date", filterable: false, width: "4rem", template: `#= expireDate ? kendo.toString(new Date(expireDate), 'dd/MM/yyyy'): '-' #` },
        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
        editable: {
          mode: "popup",
          window: { title: "Partnership" },
          template: kendo.template($("#popup-editor").html())
        }
      };
    }
  }, {
    key: "detailInit",
    value: function detailInit(e) {
      var data = e.data;
      var detailRow = e.detailRow;

      detailRow.find(".detailTabstrip").kendoTabStrip({
        animation: {
          open: { effects: "fadeIn" }
        }
      });

      detailRow.find(".users").kendoGrid({
        dataSource: this.affiliatesService.getAffiliateUsersDataSource(data.id),
        sortable: false,
        pageable: true,
        resizable: false,
        noRecords: {
          template: "None yet."
        },
        columns: [{
          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "12rem",
          template: function template(dataItem) {
            return "<a target=\"_blank\" class=\"cell\" href=\"/users/" + dataItem.userId + "\">" + dataItem.fullName + "</a>";
          }
        }, { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" }, { field: "accountStatusName", title: "Account Status", filterable: false, width: "8rem" }, { field: "membershipTypeName", title: "Membership Type", filterable: false, width: "10rem" }, { field: "creationDate", title: "Signup Date", template: "<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>", filterable: false, width: "8rem" }]
      });

      detailRow.find(".jobs").kendoGrid({
        dataSource: this.affiliatesService.getAffiliateJobsDataSource(data.id),
        sortable: false,
        pageable: true,
        resizable: false,
        noRecords: {
          template: "None yet."
        },
        columns: [{ field: "month", title: "Month", template: "<span>#= kendo.toString(new Date(month), 'MMM yyyy') #</span>", filterable: false, width: "4em" }, { field: "jobsPosted", title: "Jobs Posted", filterable: false, sortable: false, width: "2rem" }, { field: "jobsAwarded", title: "Jobs Awarded", filterable: false, sortable: false, width: "2rem" }, { field: "jobsCompleted", title: "Jobs Completed", filterable: false, sortable: false, width: "2rem" }]
      });
    }
  }, {
    key: "_getActivationDetails",
    value: function _getActivationDetails(affiliate) {
      switch (affiliate.affiliateType) {
        case _constants2.default.affiliateType.CREDIT:
          return "" + affiliate.activationsCount;
        case _constants2.default.affiliateType.SUBSCRIPTION:
          return affiliate.activationsCount + " / " + affiliate.activationsLimit;
      }

      return '';
    }
  }, {
    key: "_getAffiliateDetails",
    value: function _getAffiliateDetails(affiliate) {
      var details = '';
      switch (affiliate.affiliateType) {
        case _constants2.default.affiliateType.CREDIT:
          details = "$" + affiliate.creditAmount + " Credit";
          break;
        case _constants2.default.affiliateType.SUBSCRIPTION:
          details = "" + this.getPaymentType(affiliate.paymentType);
          if (affiliate.secondaryPaymentType) {
            details += ", " + this.getPaymentType(affiliate.secondaryPaymentType);
          }
          break;
      }

      return details;
    }
  }, {
    key: "_getAccountType",
    value: function _getAccountType(affiliate) {
      switch (affiliate.jugglerTypes) {
        case _constants2.default.jugglerType.PARENT:
          return 'Parent';
        case _constants2.default.jugglerType.HELPER:
          return 'Helper';
      }

      return 'None';
    }
  }, {
    key: "getPaymentType",
    value: function getPaymentType(paymentType) {
      if (!paymentType) return "-";

      switch (paymentType) {
        case _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION120:
        case _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180:
          return 'Childcare Membership';
        case _constants2.default.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240:
          return 'Tutoring + Childcare Membership';
        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER1_SUBSCRIPTION_500:
          return 'Juggle St Pro Quarterly - Single Site';
        case _constants2.default.userPaymentType.ANNUAL_BUSINESS_TIER1_SUBSCRIPTION_1500:
          return 'Juggle St Pro Annual - Single Site';
        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_500:
          return 'Juggle St Pro Quarterly - Agency';
        case _constants2.default.userPaymentType.ANNUAL_BUSINESS_TIER2_SUBSCRIPTION_1500:
          return 'Juggle St Pro Annual - Agency';
        case _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30:
          return 'Helper Membership';
        default:
          throw new Error("Unsupported option: " + paymentType);
      }
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.affiliatesMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }]);
  return AffiliatesController;
}();

exports.default = AffiliatesController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/affiliates/affiliates.controller.js
 **/